import { memo } from 'react';

import { Input, Toggle } from './SimpleControls';

import styles from './PopupControls.module.css';

export interface ITimeControl {
  initialMin: number;
  additionalSec: number;
  noTime: boolean;
}

export const TimeControl = memo(function TimeControl({
  value,
  onChange,
}: {
  value: ITimeControl;
  onChange: (t: ITimeControl) => void;
}) {
  return (
    <div className={styles.group}>
      <Input
        initialValue={value.initialMin.toString()}
        postfix="мин"
        notActive={value.noTime}
        onClick={() => onChange?.({ ...value, noTime: false })}
        onChange={(v) => onChange?.({ ...value, initialMin: parseInt(v, 10) })}
      />
      <Input
        initialValue={value.additionalSec.toString()}
        prefix="+"
        postfix="сек"
        notActive={value.noTime}
        onClick={() => onChange?.({ ...value, noTime: false })}
        onChange={(v) => onChange?.({ ...value, additionalSec: parseInt(v, 10) })}
      />
      <Toggle value={value.noTime} onChange={() => onChange?.({ ...value, noTime: true })}>
        <p>Без контроля</p>
      </Toggle>
    </div>
  );
});
